module.exports = "/images/veil-1.jpg";